import { useMemo, useState } from 'react'

import { BadgeEarnedPopupContext } from '../badgeEarnedPopupContext/BadgeEarnedPopupContext'

import { BadgeEarnedPopupContextControllerProps } from './BadgeEarnedPopupContextController.types'

export type BadgeEarnedPopupState = {
  shouldRefetch: boolean
}

export function BadgeEarnedPopupContextController({ children }: BadgeEarnedPopupContextControllerProps) {
  const [shouldRefetchAchievements, setShouldRefetchAchievements] = useState(false)

  const value = useMemo(
    () => ({
      shouldRefetchAchievements,
      setShouldRefetchAchievements
    }),
    [shouldRefetchAchievements]
  )

  return <BadgeEarnedPopupContext.Provider value={value}>{children}</BadgeEarnedPopupContext.Provider>
}
